import S from 'constants/string.const';
import fromAnyToString from 'utils/converters/fromAnyToString';

const fromPermissionToPretty = (value) =>
  fromAnyToString(value)
    .replaceAll(S.underscore, S.space)
    .trim();

// noinspection JSUnusedGlobalSymbols
export default fromPermissionToPretty;
